class _ {
  /**
   * Create a `FluentType` instance.
   *
   * @param value The JavaScript value to wrap.
   */
  constructor(t) {
    this.value = t;
  }
  /**
   * Unwrap the raw value stored by this `FluentType`.
   */
  valueOf() {
    return this.value;
  }
}
class l extends _ {
  /**
   * Create an instance of `FluentNone` with an optional fallback value.
   * @param value The fallback value of this `FluentNone`.
   */
  constructor(t = "???") {
    super(t);
  }
  /**
   * Format this `FluentNone` to the fallback string.
   */
  toString(t) {
    return `{${this.value}}`;
  }
}
class h extends _ {
  /**
   * Create an instance of `FluentNumber` with options to the
   * `Intl.NumberFormat` constructor.
   *
   * @param value The number value of this `FluentNumber`.
   * @param opts Options which will be passed to `Intl.NumberFormat`.
   */
  constructor(t, e = {}) {
    super(t), this.opts = e;
  }
  /**
   * Format this `FluentNumber` to a string.
   */
  toString(t) {
    try {
      return t.memoizeIntlObject(Intl.NumberFormat, this.opts).format(this.value);
    } catch (e) {
      return t.reportError(e), this.value.toString(10);
    }
  }
}
class m extends _ {
  /**
   * Create an instance of `FluentDateTime` with options to the
   * `Intl.DateTimeFormat` constructor.
   *
   * @param value The number value of this `FluentDateTime`, in milliseconds.
   * @param opts Options which will be passed to `Intl.DateTimeFormat`.
   */
  constructor(t, e = {}) {
    super(t), this.opts = e;
  }
  /**
   * Format this `FluentDateTime` to a string.
   */
  toString(t) {
    try {
      return t.memoizeIntlObject(Intl.DateTimeFormat, this.opts).format(this.value);
    } catch (e) {
      return t.reportError(e), new Date(this.value).toISOString();
    }
  }
}
const U = 100, ot = "⁨", ut = "⁩";
function at(n, t, e) {
  if (e === t || e instanceof h && t instanceof h && e.value === t.value)
    return !0;
  if (t instanceof h && typeof e == "string") {
    let r = n.memoizeIntlObject(Intl.PluralRules, t.opts).select(t.value);
    if (e === r)
      return !0;
  }
  return !1;
}
function P(n, t, e) {
  return t[e] ? p(n, t[e].value) : (n.reportError(new RangeError("No default")), new l());
}
function O(n, t) {
  const e = [], r = /* @__PURE__ */ Object.create(null);
  for (const s of t)
    s.type === "narg" ? r[s.name] = y(n, s.value) : e.push(y(n, s));
  return { positional: e, named: r };
}
function y(n, t) {
  switch (t.type) {
    case "str":
      return t.value;
    case "num":
      return new h(t.value, {
        minimumFractionDigits: t.precision
      });
    case "var":
      return lt(n, t);
    case "mesg":
      return ft(n, t);
    case "term":
      return ct(n, t);
    case "func":
      return dt(n, t);
    case "select":
      return ht(n, t);
    default:
      return new l();
  }
}
function lt(n, { name: t }) {
  let e;
  if (n.params)
    if (Object.prototype.hasOwnProperty.call(n.params, t))
      e = n.params[t];
    else
      return new l(`$${t}`);
  else if (n.args && Object.prototype.hasOwnProperty.call(n.args, t))
    e = n.args[t];
  else
    return n.reportError(new ReferenceError(`Unknown variable: $${t}`)), new l(`$${t}`);
  if (e instanceof _)
    return e;
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return new h(e);
    case "object":
      if (e instanceof Date)
        return new m(e.getTime());
    default:
      return n.reportError(new TypeError(`Variable type not supported: $${t}, ${typeof e}`)), new l(`$${t}`);
  }
}
function ft(n, { name: t, attr: e }) {
  const r = n.bundle._messages.get(t);
  if (!r)
    return n.reportError(new ReferenceError(`Unknown message: ${t}`)), new l(t);
  if (e) {
    const s = r.attributes[e];
    return s ? p(n, s) : (n.reportError(new ReferenceError(`Unknown attribute: ${e}`)), new l(`${t}.${e}`));
  }
  return r.value ? p(n, r.value) : (n.reportError(new ReferenceError(`No value: ${t}`)), new l(t));
}
function ct(n, { name: t, attr: e, args: r }) {
  const s = `-${t}`, o = n.bundle._terms.get(s);
  if (!o)
    return n.reportError(new ReferenceError(`Unknown term: ${s}`)), new l(s);
  if (e) {
    const c = o.attributes[e];
    if (c) {
      n.params = O(n, r).named;
      const w = p(n, c);
      return n.params = null, w;
    }
    return n.reportError(new ReferenceError(`Unknown attribute: ${e}`)), new l(`${s}.${e}`);
  }
  n.params = O(n, r).named;
  const f = p(n, o.value);
  return n.params = null, f;
}
function dt(n, { name: t, args: e }) {
  let r = n.bundle._functions[t];
  if (!r)
    return n.reportError(new ReferenceError(`Unknown function: ${t}()`)), new l(`${t}()`);
  if (typeof r != "function")
    return n.reportError(new TypeError(`Function ${t}() is not callable`)), new l(`${t}()`);
  try {
    let s = O(n, e);
    return r(s.positional, s.named);
  } catch (s) {
    return n.reportError(s), new l(`${t}()`);
  }
}
function ht(n, { selector: t, variants: e, star: r }) {
  let s = y(n, t);
  if (s instanceof l)
    return P(n, e, r);
  for (const o of e) {
    const f = y(n, o.key);
    if (at(n, s, f))
      return p(n, o.value);
  }
  return P(n, e, r);
}
function Q(n, t) {
  if (n.dirty.has(t))
    return n.reportError(new RangeError("Cyclic reference")), new l();
  n.dirty.add(t);
  const e = [], r = n.bundle._useIsolating && t.length > 1;
  for (const s of t) {
    if (typeof s == "string") {
      e.push(n.bundle._transform(s));
      continue;
    }
    if (n.placeables++, n.placeables > U)
      throw n.dirty.delete(t), new RangeError(`Too many placeables expanded: ${n.placeables}, max allowed is ${U}`);
    r && e.push(ot), e.push(y(n, s).toString(n)), r && e.push(ut);
  }
  return n.dirty.delete(t), e.join("");
}
function p(n, t) {
  return typeof t == "string" ? n.bundle._transform(t) : Q(n, t);
}
class Et {
  constructor(t, e, r) {
    this.dirty = /* @__PURE__ */ new WeakSet(), this.params = null, this.placeables = 0, this.bundle = t, this.errors = e, this.args = r;
  }
  reportError(t) {
    if (!this.errors || !(t instanceof Error))
      throw t;
    this.errors.push(t);
  }
  memoizeIntlObject(t, e) {
    let r = this.bundle._intls.get(t);
    r || (r = {}, this.bundle._intls.set(t, r));
    let s = JSON.stringify(e);
    return r[s] || (r[s] = new t(this.bundle.locales, e)), r[s];
  }
}
function b(n, t) {
  const e = /* @__PURE__ */ Object.create(null);
  for (const [r, s] of Object.entries(n))
    t.includes(r) && (e[r] = s.valueOf());
  return e;
}
const C = [
  "unitDisplay",
  "currencyDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits"
];
function wt(n, t) {
  let e = n[0];
  if (e instanceof l)
    return new l(`NUMBER(${e.valueOf()})`);
  if (e instanceof h)
    return new h(e.valueOf(), {
      ...e.opts,
      ...b(t, C)
    });
  if (e instanceof m)
    return new h(e.valueOf(), {
      ...b(t, C)
    });
  throw new TypeError("Invalid argument to NUMBER");
}
const K = [
  "dateStyle",
  "timeStyle",
  "fractionalSecondDigits",
  "dayPeriod",
  "hour12",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName"
];
function pt(n, t) {
  let e = n[0];
  if (e instanceof l)
    return new l(`DATETIME(${e.valueOf()})`);
  if (e instanceof m)
    return new m(e.valueOf(), {
      ...e.opts,
      ...b(t, K)
    });
  if (e instanceof h)
    return new m(e.valueOf(), {
      ...b(t, K)
    });
  throw new TypeError("Invalid argument to DATETIME");
}
const j = /* @__PURE__ */ new Map();
function gt(n) {
  const t = Array.isArray(n) ? n.join(" ") : n;
  let e = j.get(t);
  return e === void 0 && (e = /* @__PURE__ */ new Map(), j.set(t, e)), e;
}
class mt {
  /**
   * Create an instance of `FluentBundle`.
   *
   * The `locales` argument is used to instantiate `Intl` formatters used by
   * translations. The `options` object can be used to configure the bundle.
   *
   * Examples:
   *
   *     let bundle = new FluentBundle(["en-US", "en"]);
   *
   *     let bundle = new FluentBundle(locales, {useIsolating: false});
   *
   *     let bundle = new FluentBundle(locales, {
   *       useIsolating: true,
   *       functions: {
   *         NODE_ENV: () => process.env.NODE_ENV
   *       }
   *     });
   *
   * Available options:
   *
   *   - `functions` - an object of additional functions available to
   *     translations as builtins.
   *
   *   - `useIsolating` - boolean specifying whether to use Unicode isolation
   *     marks (FSI, PDI) for bidi interpolations. Default: `true`.
   *
   *   - `transform` - a function used to transform string parts of patterns.
   */
  constructor(t, { functions: e, useIsolating: r = !0, transform: s = (o) => o } = {}) {
    this._terms = /* @__PURE__ */ new Map(), this._messages = /* @__PURE__ */ new Map(), this.locales = Array.isArray(t) ? t : [t], this._functions = {
      NUMBER: wt,
      DATETIME: pt,
      ...e
    }, this._useIsolating = r, this._transform = s, this._intls = gt(t);
  }
  /**
   * Check if a message is present in the bundle.
   *
   * @param id - The identifier of the message to check.
   */
  hasMessage(t) {
    return this._messages.has(t);
  }
  /**
   * Return a raw unformatted message object from the bundle.
   *
   * Raw messages are `{value, attributes}` shapes containing translation units
   * called `Patterns`. `Patterns` are implementation-specific; they should be
   * treated as black boxes and formatted with `FluentBundle.formatPattern`.
   *
   * @param id - The identifier of the message to check.
   */
  getMessage(t) {
    return this._messages.get(t);
  }
  /**
   * Add a translation resource to the bundle.
   *
   * The translation resource must be an instance of `FluentResource`.
   *
   *     let res = new FluentResource("foo = Foo");
   *     bundle.addResource(res);
   *     bundle.getMessage("foo");
   *     // → {value: .., attributes: {..}}
   *
   * Available options:
   *
   *   - `allowOverrides` - boolean specifying whether it's allowed to override
   *     an existing message or term with a new value. Default: `false`.
   *
   * @param   res - FluentResource object.
   * @param   options
   */
  addResource(t, { allowOverrides: e = !1 } = {}) {
    const r = [];
    for (let s = 0; s < t.body.length; s++) {
      let o = t.body[s];
      if (o.id.startsWith("-")) {
        if (e === !1 && this._terms.has(o.id)) {
          r.push(new Error(`Attempt to override an existing term: "${o.id}"`));
          continue;
        }
        this._terms.set(o.id, o);
      } else {
        if (e === !1 && this._messages.has(o.id)) {
          r.push(new Error(`Attempt to override an existing message: "${o.id}"`));
          continue;
        }
        this._messages.set(o.id, o);
      }
    }
    return r;
  }
  /**
   * Format a `Pattern` to a string.
   *
   * Format a raw `Pattern` into a string. `args` will be used to resolve
   * references to variables passed as arguments to the translation.
   *
   * In case of errors `formatPattern` will try to salvage as much of the
   * translation as possible and will still return a string. For performance
   * reasons, the encountered errors are not returned but instead are appended
   * to the `errors` array passed as the third argument.
   *
   *     let errors = [];
   *     bundle.addResource(
   *         new FluentResource("hello = Hello, {$name}!"));
   *
   *     let hello = bundle.getMessage("hello");
   *     if (hello.value) {
   *         bundle.formatPattern(hello.value, {name: "Jane"}, errors);
   *         // Returns "Hello, Jane!" and `errors` is empty.
   *
   *         bundle.formatPattern(hello.value, undefined, errors);
   *         // Returns "Hello, {$name}!" and `errors` is now:
   *         // [<ReferenceError: Unknown variable: name>]
   *     }
   *
   * If `errors` is omitted, the first encountered error will be thrown.
   */
  formatPattern(t, e = null, r = null) {
    if (typeof t == "string")
      return this._transform(t);
    let s = new Et(this, r, e);
    try {
      return Q(s, t).toString(s);
    } catch (o) {
      if (s.errors && o instanceof Error)
        return s.errors.push(o), new l().toString(s);
      throw o;
    }
  }
}
const I = /^(-?[a-zA-Z][\w-]*) *= */gm, z = /\.([a-zA-Z][\w-]*) *= */y, yt = /\*?\[/y, $ = /(-?[0-9]+(?:\.([0-9]+))?)/y, vt = /([a-zA-Z][\w-]*)/y, k = /([$-])?([a-zA-Z][\w-]*)(?:\.([a-zA-Z][\w-]*))?/y, bt = /^[A-Z][A-Z0-9_-]*$/, v = /([^{}\n\r]+)/y, _t = /([^\\"\n\r]*)/y, Z = /\\([\\"])/y, V = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{6})/y, Rt = /^\n+/, G = / +$/, St = / *\r?\n/g, xt = /( *)$/, It = /{\s*/y, W = /\s*}/y, $t = /\[\s*/y, At = /\s*] */y, Ot = /\s*\(\s*/y, Tt = /\s*->\s*/y, Nt = /\s*:\s*/y, Ft = /\s*,?\s*/y, Bt = /\s+/y;
class Dt {
  constructor(t) {
    this.body = [], I.lastIndex = 0;
    let e = 0;
    for (; ; ) {
      let i = I.exec(t);
      if (i === null)
        break;
      e = I.lastIndex;
      try {
        this.body.push(w(i[1]));
      } catch (u) {
        if (u instanceof SyntaxError)
          continue;
        throw u;
      }
    }
    function r(i) {
      return i.lastIndex = e, i.test(t);
    }
    function s(i, u) {
      if (t[e] === i)
        return e++, !0;
      if (u)
        throw new u(`Expected ${i}`);
      return !1;
    }
    function o(i, u) {
      if (r(i))
        return e = i.lastIndex, !0;
      if (u)
        throw new u(`Expected ${i.toString()}`);
      return !1;
    }
    function f(i) {
      i.lastIndex = e;
      let u = i.exec(t);
      if (u === null)
        throw new SyntaxError(`Expected ${i.toString()}`);
      return e = i.lastIndex, u;
    }
    function c(i) {
      return f(i)[1];
    }
    function w(i) {
      let u = R(), a = Y();
      if (u === null && Object.keys(a).length === 0)
        throw new SyntaxError("Expected message value or attributes");
      return { id: i, value: u, attributes: a };
    }
    function Y() {
      let i = /* @__PURE__ */ Object.create(null);
      for (; r(z); ) {
        let u = c(z), a = R();
        if (a === null)
          throw new SyntaxError("Expected attribute value");
        i[u] = a;
      }
      return i;
    }
    function R() {
      let i;
      if (r(v) && (i = c(v)), t[e] === "{" || t[e] === "}")
        return S(i ? [i] : [], 1 / 0);
      let u = M();
      return u ? i ? S([i, u], u.length) : (u.value = x(u.value, Rt), S([u], u.length)) : i ? x(i, G) : null;
    }
    function S(i = [], u) {
      for (; ; ) {
        if (r(v)) {
          i.push(c(v));
          continue;
        }
        if (t[e] === "{") {
          i.push(N());
          continue;
        }
        if (t[e] === "}")
          throw new SyntaxError("Unbalanced closing brace");
        let d = M();
        if (d) {
          i.push(d), u = Math.min(u, d.length);
          continue;
        }
        break;
      }
      let a = i.length - 1, E = i[a];
      typeof E == "string" && (i[a] = x(E, G));
      let g = [];
      for (let d of i)
        d instanceof q && (d = d.value.slice(0, d.value.length - u)), d && g.push(d);
      return g;
    }
    function N() {
      o(It, SyntaxError);
      let i = F();
      if (o(W))
        return i;
      if (o(Tt)) {
        let u = nt();
        return o(W, SyntaxError), {
          type: "select",
          selector: i,
          ...u
        };
      }
      throw new SyntaxError("Unclosed placeable");
    }
    function F() {
      if (t[e] === "{")
        return N();
      if (r(k)) {
        let [, i, u, a = null] = f(k);
        if (i === "$")
          return { type: "var", name: u };
        if (o(Ot)) {
          let E = tt();
          if (i === "-")
            return { type: "term", name: u, attr: a, args: E };
          if (bt.test(u))
            return { type: "func", name: u, args: E };
          throw new SyntaxError("Function names must be all upper-case");
        }
        return i === "-" ? {
          type: "term",
          name: u,
          attr: a,
          args: []
        } : { type: "mesg", name: u, attr: a };
      }
      return B();
    }
    function tt() {
      let i = [];
      for (; ; ) {
        switch (t[e]) {
          case ")":
            return e++, i;
          case void 0:
            throw new SyntaxError("Unclosed argument list");
        }
        i.push(et()), o(Ft);
      }
    }
    function et() {
      let i = F();
      return i.type !== "mesg" ? i : o(Nt) ? {
        type: "narg",
        name: i.name,
        value: B()
      } : i;
    }
    function nt() {
      let i = [], u = 0, a;
      for (; r(yt); ) {
        s("*") && (a = u);
        let E = rt(), g = R();
        if (g === null)
          throw new SyntaxError("Expected variant value");
        i[u++] = { key: E, value: g };
      }
      if (u === 0)
        return null;
      if (a === void 0)
        throw new SyntaxError("Expected default variant");
      return { variants: i, star: a };
    }
    function rt() {
      o($t, SyntaxError);
      let i;
      return r($) ? i = D() : i = {
        type: "str",
        value: c(vt)
      }, o(At, SyntaxError), i;
    }
    function B() {
      if (r($))
        return D();
      if (t[e] === '"')
        return it();
      throw new SyntaxError("Invalid expression");
    }
    function D() {
      let [, i, u = ""] = f($), a = u.length;
      return {
        type: "num",
        value: parseFloat(i),
        precision: a
      };
    }
    function it() {
      s('"', SyntaxError);
      let i = "";
      for (; ; ) {
        if (i += c(_t), t[e] === "\\") {
          i += st();
          continue;
        }
        if (s('"'))
          return { type: "str", value: i };
        throw new SyntaxError("Unclosed string literal");
      }
    }
    function st() {
      if (r(Z))
        return c(Z);
      if (r(V)) {
        let [, i, u] = f(V), a = parseInt(i || u, 16);
        return a <= 55295 || 57344 <= a ? String.fromCodePoint(a) : "�";
      }
      throw new SyntaxError("Unknown escape sequence");
    }
    function M() {
      let i = e;
      switch (o(Bt), t[e]) {
        case ".":
        case "[":
        case "*":
        case "}":
        case void 0:
          return !1;
        case "{":
          return L(t.slice(i, e));
      }
      return t[e - 1] === " " ? L(t.slice(i, e)) : !1;
    }
    function x(i, u) {
      return i.replace(u, "");
    }
    function L(i) {
      let u = i.replace(St, `
`), a = xt.exec(i)[1].length;
      return new q(u, a);
    }
  }
}
class q {
  constructor(t, e) {
    this.value = t, this.length = e;
  }
}
function A(n, t) {
  if (typeof n != "string" || typeof t != "string")
    throw new Error("called addValue with a non-string key or value");
  if (t && t.indexOf(`
`) > -1) {
    const e = `
  `, r = t.split(`
`).join(e);
    return `${n} =${e}${r}`;
  } else
    return `${n} = ${t}`;
}
function Mt(n) {
  if (typeof n != "string")
    throw new Error("called addComment with non-string value");
  return `# ${n.split(`
`).join(`
# `)}
`;
}
function Lt(n, t) {
  const e = Object.entries(n).map(([r, s]) => {
    const o = [];
    if (typeof s == "string")
      return `${A(r, s)}

`;
    if (s.comment && o.push(Mt(s.comment)), typeof s.value != "string")
      throw new Error(`Value ${r} with attributes had no value. Found: ${s.value}`);
    return o.push(A(r, s.value)), Object.entries(s).forEach(([f, c]) => {
      if (!(f === "comment" || f === "value")) {
        if (typeof c != "string")
          throw new Error(`Inner value ${f} with attributes had no value. Found: ${c}`);
        o.push(A(`
  .` + f, c));
      }
    }), o.push(`

`), o.join("");
  }).join("");
  return t && t(null, e), e;
}
function Ut(n, t, e, r) {
  n[t] == null && (n[t] = {}), n[t][e] = r;
}
function Pt(n, t, e) {
  if (n !== void 0 && n[t] !== void 0 && n[t][e] !== void 0)
    return n[t][e];
}
function Ct(n, t, e) {
  if (n !== void 0 && n[t] !== void 0 && n[t][e] !== void 0)
    return n[t][e];
}
function Kt(n) {
  return !/^\s*$/.test(n);
}
function jt(n) {
  return (n.match(/^\s*/) || []).length;
}
function zt(n) {
  const t = n.split(`
`).filter(Kt), e = t.map(jt), r = Math.min(...e), s = new RegExp(`^\\s{${r}}`);
  return t.map((o) => o.replace(s, "")).join(`
`);
}
class X {
  constructor(t, e) {
    this.i18next = e, this.options = t, this.bundles = {};
  }
  createBundle(t, e, r) {
    const s = r !== void 0 ? Lt(r) : "", o = new mt(t, this.options.fluentBundleOptions), f = o.addResource(new Dt(zt(s)));
    if (f.length != 0)
      throw new Error(`Failed to add FluentResource to bundle without errors: ${f.join(`
`)}`);
    Ut(this.bundles, t, e, o);
  }
  createBundleFromI18next(t, e) {
    var r, s;
    if (((r = this.i18next) == null ? void 0 : r.store.data) !== void 0) {
      const o = Ct((s = this.i18next) == null ? void 0 : s.store.data, t, e);
      o !== void 0 && this.createBundle(t, e, o);
    }
  }
  getBundle(t, e) {
    return Pt(this.bundles, t, e);
  }
  bind() {
    this.i18next && (this.i18next.store.on("added", (t, e) => {
      var r;
      (r = this.i18next) != null && r.isInitialized && this.createBundleFromI18next(t, e);
    }), this.i18next.on("initialized", () => {
      if (this.i18next) {
        const t = this.i18next.languages || [], e = this.i18next.options.preload || [], r = this.i18next.options.ns;
        t.filter((s) => !e.includes(s)).concat(e).forEach((s) => {
          typeof r != "string" && (r == null || r.forEach((o) => {
            this.createBundleFromI18next(s, o);
          }));
        });
      }
    }));
  }
}
function J() {
  return {
    bindI18nStore: !0,
    fluentBundleOptions: { useIsolating: !1 }
  };
}
const T = class T {
  constructor(t) {
    this.type = "i18nFormat", this.handleAsObject = !1, this.options = { ...t, ...J() }, this.store = new X(this.options);
  }
  init(t, e) {
    var s;
    const r = ((s = t == null ? void 0 : t.options) == null ? void 0 : s.i18nFormat) || {};
    this.options = { ...r, ...e, ...this.options, ...J() }, this.store = new X(this.options, t), this.options.bindI18nStore && this.store.bind(), t.fluent = this;
  }
  parse(t, e, r, s, o) {
    const f = this.store.getBundle(r, s), c = o.indexOf(".") > -1;
    if (!t) return o;
    const w = c ? t.attributes[o.split(".")[1]] : t.value;
    return !f || !w ? o : f.formatPattern(w, e);
  }
  getResource(t, e, r) {
    const s = this.store.getBundle(t, e), o = r.indexOf(".") > -1 ? r.split(".")[0] : r;
    if (s)
      return s.getMessage(o);
  }
  addLookupKeys(t) {
    return t;
  }
};
T.type = "i18nFormat";
let H = T;
export {
  H as Fluent,
  H as default
};
//# sourceMappingURL=main.js.map
